// extracted by mini-css-extract-plugin
module.exports = {"legalFooter":"bt_g6","grid":"bt_bk","copyright":"bt_g7","actions":"bt_g8","rrss":"bt_g9","links":"bt_hb","link":"bt_cn","languageSelector":"bt_hc","legalFooterDark":"bt_hd"};